import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Formik, FormikValues } from 'formik';
import { MyThunkDispatch, RootState } from 'store';
import * as yup from 'yup';

import { applyConfiguration } from 'actions/companyConfiguration';
import { updateAccount } from 'actions/user';
import Header from 'components/AppBar';
import SubmitButton from 'components/Buttons/SubmitButton';
import FormikSubmitErrorEffect from 'components/FormikSubmitErrorEffect';
import Input from 'components/Input';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import Section from 'components/Section';
import useUserAccount from 'hooks/useUserAccount';
import { CompanyConfiguration } from 'models/company';

import { Container, Wrapper, FormContainer, Field, CloseButton, CloseIcon } from './styles';

const ResellerCustomization = () => {
  const history = useHistory();
  const dispatch: MyThunkDispatch = useDispatch();

  const companyConfiguration = useSelector((state: RootState) => state.companyConfiguration.configuration);
  const account = useUserAccount();

  const handleSubmit = (values: any) => {
    console.log(values);
    dispatch(
      applyConfiguration({
        ...companyConfiguration,
        imageLogo: values.imageLogo,
        primaryBackgroundColor: values.primaryBackgroundColor,
        primaryColor: values.primaryColor,
        secondaryBackgroundColor: values.secondaryBackgroundColor,
        secondaryColor: values.secondaryColor,
        tertiaryBackgroundColor: values.tertiaryBackgroundColor,
        tertiaryColor: values.tertiaryColor,
        ownerCompanyName: values.ownerCompanyName,
        ownerImageLogo: values.ownerImageLogo,
        companyName: values.companyName,
      } as CompanyConfiguration),
    );

    updateAccount(dispatch, { ...account, countryCurrency: values.countryCurrency });
  };

  const validationSchema = yup.object().shape({
    imageLogo: yup.string(),
    primaryBackgroundColor: yup.string().required(),
    primaryColor: yup.string().required(),
    secondaryBackgroundColor: yup.string().required(),
    secondaryColor: yup.string().required(),
    tertiaryBackgroundColor: yup.string().required(),
    tertiaryColor: yup.string().required(),
    ownerImageLogo: yup.string().required(),
    ownerCompanyName: yup.string().required(),
    companyName: yup.string(),
    countryCurrency: yup.string().required(),
  });

  const initValues = {
    imageLogo: companyConfiguration?.imageLogo || '',
    primaryBackgroundColor: companyConfiguration?.primaryBackgroundColor || '',
    primaryColor: companyConfiguration?.primaryColor || '',
    secondaryBackgroundColor: companyConfiguration?.secondaryBackgroundColor || '',
    secondaryColor: companyConfiguration?.secondaryColor || '',
    tertiaryBackgroundColor: companyConfiguration?.tertiaryBackgroundColor || '',
    tertiaryColor: companyConfiguration?.tertiaryColor || '',
    ownerImageLogo: companyConfiguration?.ownerImageLogo || '',
    ownerCompanyName: companyConfiguration?.ownerCompanyName || '',
    companyName: companyConfiguration?.companyName || '',
    countryCurrency: account.countryCurrency || 'COP',
  };

  return (
    <Wrapper className="target">
      <>
        <Mobile>
          <Header goBack={() => history.push('/corporate/booking')}>Personalización a la medida</Header>
        </Mobile>

        <Desktop>
          <ScreenHeader
            title="Personalización a la medida"
            subtitle="Los estilos serán aplicados solamente durante el tiempo de sesión"
            right={
              <CloseButton onClick={() => history.goBack()}>
                <CloseIcon />
              </CloseButton>
            }
          />
        </Desktop>

        <Container>
          <Formik
            initialStatus={{ rightCheckIfIsValid: true }}
            initialValues={initValues}
            validationSchema={validationSchema}
            onSubmit={(value) => handleSubmit(value)}
            isInitialValid={(formik: FormikValues) => validationSchema.isValidSync(formik.initialValues)}
          >
            {({ dirty, isSubmitting, isValid, values }: FormikValues) => (
              <>
                <FormikSubmitErrorEffect />

                <FormContainer marginBottom={dirty}>
                  <Section title="Monedas & Culturas" joinContent={false}>
                    <Field name="countryCurrency" label="Moneda del Flujo de Reserva">
                      <Input placeholder="Poner el formato ISO de la moneda (COP, BRL, USD, MXN, EUR...)" />
                    </Field>
                  </Section>
                  <Section title="Colores y Logo" joinContent={false}>
                    <Field name="ownerCompanyName" label="Nombre Reseller">
                      <Input placeholder="Dejando este campo vacio, el logo del reseller no aparecerá" />
                    </Field>
                    <Field name="ownerImageLogo" label="Logo Reseller">
                      <Input placeholder="Pon el enlace con http:// - dejando este campo vacio, el logo del reseller no aparecerá" />
                    </Field>
                    <Field name="companyName" label="Nombre del Cliente (no obligatório)">
                      <Input placeholder="Pon el nombre de la empresa que usará Corporate" />
                    </Field>
                    <Field name="imageLogo" label="Logo del Cliente (no obligatório)">
                      <Input placeholder="Pon el enlace con http://" />
                    </Field>
                    <Field
                      name="primaryBackgroundColor"
                      label={`Color Primario para Fondos: ${values.primaryBackgroundColor}`}
                    >
                      <Input type="color" placeholder="#FFFFFF" />
                    </Field>
                    <Field name="primaryColor" label={`Color Primario para Textos: ${values.primaryColor}`}>
                      <Input type="color" placeholder="#FFFFFF" />
                    </Field>
                    <Field
                      name="secondaryBackgroundColor"
                      label={`Color Secundario para Fondos: ${values.secondaryBackgroundColor}`}
                    >
                      <Input type="color" placeholder="#FFFFFF" />
                    </Field>
                    <Field name="secondaryColor" label={`Color Secundario para Textos: ${values.secondaryColor}`}>
                      <Input type="color" placeholder="#FFFFFF" />
                    </Field>
                    <Field
                      name="tertiaryBackgroundColor"
                      label={`Color Terciario para Fondos: ${values.tertiaryBackgroundColor}`}
                    >
                      <Input type="color" placeholder="#FFFFFF" />
                    </Field>
                    <Field name="tertiaryColor" label={`Color Terciario para Textos: ${values.tertiaryColor}`}>
                      <Input type="color" placeholder="#FFFFFF" />
                    </Field>
                  </Section>
                  <Mobile>
                  <Section></Section>
                  <Section></Section>
                  </Mobile>

                  <SubmitButton dirty={true} isEdit loading={false}>
                    Aplicar
                  </SubmitButton>
                </FormContainer>
              </>
            )}
          </Formik>
        </Container>
      </>
    </Wrapper>
  );
};

export default ResellerCustomization;
